import { Component, OnInit } from '@angular/core';
import { UntypedFormGroup, FormBuilder, Validators } from '@angular/forms';
import { AbstractDialogComponent, AuthStoreService } from '@motivforce/mx-library-angular';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { filter } from 'rxjs';
import { PromotionStoreService } from 'src/app/core/store/promotion-store.service';

@UntilDestroy()
@Component({
  selector: 'app-promotion-terms-conditions-accept-dialog',
  templateUrl: './promotion-terms-conditions-accept-dialog.component.html',
  styleUrls: ['./promotion-terms-conditions-accept-dialog.component.scss'],
})
export class PromotionTermsConditionsAcceptDialogComponent extends AbstractDialogComponent implements OnInit {
  promotionId: number;
  tncBody: string;
  tncAccept: string;
  showJobTitleField = false;

  formGroup: UntypedFormGroup = this.formBuilder.group({
    tnCs: [false, Validators.requiredTrue],
  });

  constructor(
    public activeModal: NgbActiveModal,
    private promotionStore: PromotionStoreService,
    private formBuilder: FormBuilder,
    private authStore: AuthStoreService
  ) {
    super();
  }

  ngOnInit(): void {
    if (this.inputs && this.inputs.length > 2) {
      this.promotionId = this.inputs[0];
      this.tncBody = this.inputs[1];
      this.tncAccept = this.inputs[2];
      if (this.inputs[3]) {
        this.showJobTitleField = this.inputs[3];
      }
    }
    if (this.showJobTitleField) {
      this.formGroup.addControl(
        'jobTitle',
        this.formBuilder.control(null, [Validators.required, Validators.maxLength(100)])
      );
    }

    this.authStore.userSettings$.pipe(untilDestroyed(this), filter(Boolean)).subscribe((settings: any) => {
      if (this.showJobTitleField && settings.user.jobTitle) {
        this.formGroup.get('jobTitle')?.patchValue(settings.user.jobTitle);
      }
    });
  }

  onSubmit(): void {
    if (this.formGroup.valid) {
      const jobTitle = this.formGroup.get('jobTitle')?.value ?? undefined;

      this.promotionStore.submitTnC(this.promotionId, jobTitle).then((result) => {
        if (result) {
          this.promotionStore.getPromotion(this.promotionId);
          this.activeModal.close(true);
          if (jobTitle) {
            this.authStore.getUserSettings();
          }
        }
      });
    }
  }
}
